import { api } from '../../../../../lib';
import { SupplierNegotiationConfigSchema } from './SetupSupplierNegotiationConfig.schema';

const SUPPLIER_NEGOTIATION_CONFIG_URL = '/setup/negotiation-cost';

export const postSupplierNegotiationConfig = async (data: Omit<SupplierNegotiationConfigSchema, 'id'>): Promise<Required<SupplierNegotiationConfigSchema>> => {
  const response = await api.post<Required<SupplierNegotiationConfigSchema>>(SUPPLIER_NEGOTIATION_CONFIG_URL, data, {
    expectToken: true,
  });

  return response.data;
};

export const putSupplierNegotiationConfig = async (data: Omit<SupplierNegotiationConfigSchema, 'id'>): Promise<Required<SupplierNegotiationConfigSchema>> => {
  const response = await api.put<Required<SupplierNegotiationConfigSchema>>(SUPPLIER_NEGOTIATION_CONFIG_URL, data, {
    expectToken: true,
  });

  return response.data;
};
